var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTransformationJob = function SvgTransformationJob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 0.5,
    y: 0.5,
    fill: "#EAEFE5",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F581A",
    d: "M11.95 5.675h-5.9v1.2h2.19v5.45h1.52v-5.45h2.19v-1.2Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 0.5,
    y: 0.5,
    stroke: "#2D8825",
    rx: 3.5
  })));
};
export { SvgTransformationJob as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMTciIGhlaWdodD0iMTciIHJ4PSIzLjUiIGZpbGw9IiNFQUVGRTUiLz4KICAgIDxwYXRoIGQ9Ik0xMS45NSA1LjY3NTA1SDYuMDQ5OTlWNi44NzUwNUg4LjIzOTk5VjEyLjMyNUg5Ljc1OTk5VjYuODc1MDVIMTEuOTVWNS42NzUwNVoiIGZpbGw9IiMxRjU4MUEiLz4KICAgIDxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMTciIGhlaWdodD0iMTciIHJ4PSIzLjUiIHN0cm9rZT0iIzJEODgyNSIvPgo8L3N2Zz4K";